// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__3TFPb","sendOtp":"AuthorizeToLogin_sendOtp__38Lzw"};